<template>
  <template
    v-for="(btn, index) in filter_head_btn_list"
    :key="index"
  >
    <a-button
      v-if="!btn.children || btn.children?.length == 0"
      :type="btn.clazz"
      size="small"
      style="margin-right: 5px"
      :disabled="btn.disabled"
      @click="
        handleBtnClick(btn, {
          dataSource: dataSource,
          selectedRowKeys: selectedRowKeys,
          current_org: current_org,
          router: router,
        })
      "
    >
      <plus-outlined v-if="btn.icon === 'plus-outlined'" />
      {{ btn.name }}
    </a-button>
    <a-dropdown
      v-else
      v-model:open="isMenuOpen[index]"
      trigger="click"
    >
      <a-button
        :bordered="false"
        size="small"
      >
        {{ btn.name }}
        <down-outlined
          v-if="!isMenuOpen[index]"
          style="font-size: 10px; cursor: pointer"
        />
        <up-outlined
          v-if="isMenuOpen[index]"
          style="font-size: 10px; cursor: pointer"
        />
      </a-button>
      <template #overlay>
        <a-menu>
          <head-btn-children
            :children_list="btn.children"
            :selected-row-keys="selectedRowKeys"
            :dataSource="dataSource"
            :current_org="current_org"
            :handleBtnClick="handleBtnClick"
          />
        </a-menu>
      </template>
    </a-dropdown>
  </template>
</template>
<script lang="ts">
import { defineComponent, computed, PropType, ref } from 'vue';
import { checkCondition, nested_sort_list } from 'liyu-pc-base/utils/function';
import { HeadBtnListConfig } from 'liyu-pc-base/api/typing';
import { head_btn_confirm } from './head_btn_confirm';
import { head_btn_custom_component } from './head_btn_custom_component';
import { head_btn_form } from './head_btn_form';
import { useI18n } from 'vue-i18n';
import { cloneDeep } from 'lodash';
import { useRoute } from 'vue-router';
import HeadBtnChildren from './headBtnChildren.vue';

export default defineComponent({
  name: 'HeadBtn',
  props: {
    auth_batch_update_list: {
      type: Array as PropType<HeadBtnListConfig>,
      required: true,
    },
    auth_head_btn_list: {
      type: Array as PropType<HeadBtnListConfig>,
      required: true,
    },
    selectedRowKeys: {
      type: Array as PropType<any[]>,
      required: true,
    },
    dataSource: {
      type: Array as PropType<any[]>,
      required: true,
    },
    current_org: {
      type: Object as PropType<any>,
      required: true,
    },
    router: {
      type: Object as PropType<any>,
      required: true,
    },
    event_obj: {
      type: Object as PropType<any>,
      required: true,
    },
  },
  components: {
    HeadBtnChildren,
  },
  setup(props) {
    const { t } = useI18n();
    const isMenuOpen = ref<Record<string, boolean>>({});
    const route = useRoute();
    const process_list = (
      list: any,
      {
        dataSource,
        selectedRowKeys,
        batchList,
      }: { dataSource: any[]; selectedRowKeys: any[]; batchList: any[] | null },
    ) => {
      if (batchList?.length > 0) {
        const batchGroup = list.find((item: any) => item.name === '批量操作');
        if (batchGroup) {
          if (!batchGroup.children || batchGroup.children.length == 0) {
            batchGroup.children = batchList;
          } else {
            batchGroup.children = [...batchGroup.children, ...batchList];
          }
        } else {
          list.push({
            name: '批量操作',
            order: 1000,
            children: batchList,
          });
        }
      }
      const result = list.filter((button: any) => {
        let data = dataSource;
        // if (button.preProcessData) {
        //   data = button.preProcessData({ dataSource: data, selectedRowKeys });
        // }
        let isDisabled = false;
        if (typeof button.is_disabled === 'function') {
          isDisabled = button.is_disabled({ dataSource: data, selectedRowKeys: selectedRowKeys });
        }
        if (typeof button.is_disabled === 'boolean') {
          isDisabled = button.is_disabled;
        }
        if (button.disabled_condition && button.disabled_condition.length > 0) {
          isDisabled = checkCondition({
            conditions: button.disabled_condition,
            dataSource: data,
            selectedRowKeys: selectedRowKeys,
          });
        }
        button.disabled = isDisabled;

        if (button.show_condition && button.show_condition.length > 0) {
          return checkCondition({
            conditions: button.show_condition,
            dataSource: data,
            selectedRowKeys: selectedRowKeys,
          });
        }

        if (typeof button.is_show === 'function') {
          return button.is_show({ dataSource: data, selectedRowKeys: selectedRowKeys });
        }
        if (typeof button.is_show === 'boolean') {
          return button.is_show;
        }
        return true;
      });
      result.forEach((item: any) => {
        if (item.children) {
          item.children = process_list(item.children, {
            dataSource: dataSource,
            selectedRowKeys: selectedRowKeys,
            batchList: null,
          });
        }
      });
      return result;
    };
    const filter_head_btn_list = computed(() => {
      if (!props.auth_head_btn_list) return [];
      const list = process_list(cloneDeep(props.auth_head_btn_list), {
        dataSource: props.dataSource,
        selectedRowKeys: props.selectedRowKeys,
        batchList: props.auth_batch_update_list,
      });
      nested_sort_list(list);
      return list;
    });
    // 处理按钮点击事件
    const handleBtnClick = (btn: any, params: any) => {
      let action_func = null;
      let query_json = {};
      if (route.query?.query_json) {
        query_json = JSON.parse(route.query?.query_json as any);
      }
      const routeQueryParams = JSON.parse(JSON.stringify({ ...route.query, ...query_json }));
      if (!btn.model_kind) {
        action_func = btn.cb;
      } else if (btn.model_kind === 'confirm') {
        action_func = head_btn_confirm;
      } else if (btn.model_kind === 'custom_component') {
        action_func = head_btn_custom_component;
      } else if (btn.model_kind === 'form') {
        action_func = head_btn_form;
      }

      if (!action_func) return;

      action_func({
        ...params,
        button: btn,
        t: t,
        current_org: props.current_org,
        routeQueryParams: routeQueryParams,
        event_obj: props.event_obj,
      });
    };
    return {
      filter_head_btn_list,
      handleBtnClick,
      isMenuOpen,
    };
  },
});
</script>
